import * as React from 'react';
const SvgBrokenLink = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={241}
    height={240}
    fill="none"
    viewBox="0 0 241 240"
    {...props}
  >
    <path
      fill="#FFECEB"
      d="M120.5 204c46.39 0 84-37.61 84-84s-37.61-84-84-84-84 37.61-84 84 37.61 84 84 84"
    />
    <path
      fill="#F77167"
      d="M155.74 167.45c.53-2.21 3.67-2.21 4.21 0l.71 2.94c.19.79.81 1.41 1.6 1.6l2.93.71c2.21.53 2.21 3.68 0 4.21l-2.93.71c-.79.19-1.41.81-1.6 1.6l-.71 2.94c-.53 2.21-3.67 2.21-4.21 0l-.71-2.94a2.17 2.17 0 0 0-1.6-1.6l-2.93-.71c-2.21-.53-2.21-3.68 0-4.21l2.93-.71a2.17 2.17 0 0 0 1.6-1.6z"
    />
    <path
      fill="#FF988F"
      fillRule="evenodd"
      d="M129.85 24.7a1.9 1.9 0 1 0 .002-3.798 1.9 1.9 0 0 0-.002 3.798m0 2.6c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5"
      clipRule="evenodd"
    />
    <path
      fill="#FFD4D2"
      d="M53.83 48.9a.6.6 0 0 1-.07-.25c0-.09 0-.18.03-.26a.8.8 0 0 1 .14-.23c.06-.06.14-.12.22-.15 2.41-.96 10.93-3.8 15.58 1.93 3.12 3.78 7.53 6.27 12.38 6.98.12.02.23.07.32.15s.15.19.18.31.02.24-.02.36c-.04.11-.12.21-.22.28-4.13 2.91-17.73 10.35-28.54-9.13zM211.15 127.62c.04-.07.06-.15.07-.23 0-.08 0-.16-.03-.24a.56.56 0 0 0-.32-.34c-2.17-.87-9.86-3.44-14.06 1.75a17.84 17.84 0 0 1-11.15 6.3.575.575 0 0 0-.47.42.5.5 0 0 0 .02.32c.04.1.11.19.2.26 3.71 2.63 15.98 9.34 25.74-8.24M56.09 77.77s.07-.11.09-.17.02-.13 0-.19a.45.45 0 0 0-.07-.18c-.04-.05-.08-.1-.14-.13-1.6-.98-7.33-4.07-11.37-.59-2.69 2.3-6.14 3.53-9.68 3.45a.43.43 0 0 0-.25.07.47.47 0 0 0-.17.2c-.04.08-.05.17-.03.26s.06.17.12.23c2.55 2.62 11.33 9.63 21.48-2.94z"
    />
    <path
      fill="#FFD4D2"
      fillRule="evenodd"
      d="M19.95 138.89a1.9 1.9 0 1 0 .002-3.798 1.9 1.9 0 0 0-.002 3.798m0 2.6c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5"
      clipRule="evenodd"
    />
    <path
      fill="#F77167"
      d="M80.45 12.06c.5-2.09 3.48-2.09 3.98 0l.76 3.17c.18.75.76 1.33 1.51 1.51l3.17.76c2.09.5 2.09 3.48 0 3.98l-3.17.76c-.75.18-1.33.76-1.51 1.51l-.76 3.17c-.5 2.09-3.48 2.09-3.98 0l-.76-3.17c-.18-.75-.76-1.33-1.51-1.51l-3.17-.76c-2.09-.5-2.09-3.48 0-3.98l3.17-.76c.75-.18 1.33-.76 1.51-1.51z"
    />
    <path
      fill="#FF988F"
      d="M127.41 201.75c.4-1.32 2.09-1.72 3.04-.7l5.22 5.57c.95 1.01.45 2.67-.9 2.98l-7.42 1.72c-1.35.31-2.54-.95-2.13-2.28l2.21-7.29z"
    />
    <path
      fill="#FFD4D2"
      d="M179.71 162.45s-.04-.1-.05-.15c0-.05 0-.11.02-.16a.42.42 0 0 1 .22-.23c1.46-.58 6.62-2.31 9.44 1.17 1.89 2.29 4.56 3.8 7.49 4.24.08 0 .15.04.21.09a.374.374 0 0 1-.05.6c-2.49 1.78-10.73 6.28-17.29-5.55z"
    />
    <path
      fill="#F77167"
      d="M103.48 135.04c-15.72-15.72-15.72-41.3 0-57.02l34.21-34.21c15.72-15.72 41.3-15.72 57.02 0s15.72 41.3 0 57.02l-34.21 34.21c-15.72 15.72-41.3 15.72-57.02 0m79.83-79.83c-9.43-9.43-24.78-9.43-34.21 0l-34.21 34.21c-9.43 9.43-9.43 24.78 0 34.21s24.78 9.43 34.21 0l34.21-34.21c9.43-9.43 9.43-24.78 0-34.21"
    />
    <path
      fill="#C93929"
      d="m85.81 116.86-1.46-2.31a.9.9 0 0 0-.29-.29l-3.04-1.92a.97.97 0 0 1-.39-.48l-1.24-3.47a.95.95 0 0 0-.57-.57l-2.37-.84a.948.948 0 0 1-.35-1.56l6-6c15.72-15.72 41.3-15.72 57.02 0a40.34 40.34 0 0 1 11.14 35.83l-15.86-2.92a24.22 24.22 0 0 0-10.19-24.41c-9.68-6.61-22.8-5.01-31.09 3.28l-5.84 5.84a.948.948 0 0 1-1.47-.16zM46.27 196.28c-13.82-13.82-15.89-36.09-3.99-52.33l9.22-12.58a.96.96 0 0 1 1.63.12l1.6 3.03c.17.32.5.51.85.51h6.05c.31 0 .61.15.79.41l2.59 3.65c.24.34.24.8 0 1.13l-9.72 13.26c-7.89 10.76-5.55 25.93 5.21 33.81 10.76 7.89 25.93 5.55 33.81-5.21l6.76-9.22c.21-.29.65-.24.8.08l1.5 3.21c.07.14.19.24.35.26l4.45.74c.09.01.17.06.24.12l2.87 2.63s.06.05.09.06l2.73 1.53c.24.14.31.46.15.68l-6.49 8.85c-12.81 17.48-37.23 22.34-55.27 10.33a40.7 40.7 0 0 1-6.21-5.08zM119.76 174.26l-1.19-2.6a.82.82 0 0 0-.39-.39l-3.29-1.5c-.22-.1-.39-.3-.45-.54l-.87-3.76c-.07-.3-.3-.53-.6-.6l-2.74-.64a.794.794 0 0 1-.38-1.34l17.87-17.87c2.15-2.15 3.85-4.63 5.06-7.38l14.77 6.47c-2.01 4.6-4.85 8.74-8.42 12.32l-18.07 18.07a.802.802 0 0 1-1.29-.23z"
    />
    <path
      fill="#F77167"
      d="m103.48 135.04 11.4-11.4c9.43 9.43 24.78 9.43 34.21 0l34.21-34.21 11.4 11.4-34.21 34.21c-15.72 15.72-41.3 15.72-57.02 0z"
    />
    <path
      fill="#C93929"
      d="m69.13 107.41-6.38-10.03c-.4-.63-1.28-.72-1.8-.2l-5.58 5.58c-.6.6-.38 1.62.42 1.91l11.97 4.44c1.04.39 1.98-.77 1.39-1.71zM59.34 118.42l-7.19-3.13c-.62-.27-1.35-.11-1.8.41l-4.31 4.98c-.78.9-.31 2.3.85 2.54l7.17 1.54c.45.1.92-.01 1.29-.3l4.33-3.38c.93-.73.75-2.18-.34-2.66M75.96 122.42l-3.95-6.95c-.48-.84-1.74-.67-1.97.27l-1.35 5.48c-.09.36.02.75.28 1.01l3.39 3.39c.42.42 1.09.42 1.51 0l1.92-1.92c.34-.34.41-.87.17-1.28"
    />
  </svg>
);
export default SvgBrokenLink;
